import React from 'react';
import Reflux from 'reflux';
import AppStore from '../AppStore';
import AppActions from '../AppActions';
import SearchStore from '../stores/SearchStore';
import history from '../history';
import Header from './Header';
import {Link} from 'react-router-dom';
import './HeaderBuscador.css';
class HeaderBuscador extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            error: '',
            query: '',
            user: {},
            loggedIn: false,
            randomSentences: [],
            userLogged: false,
            userData: {}
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.selectSearch = this.selectSearch.bind(this);
        this.logout = this.logout.bind(this);
        this.stores = [AppStore, SearchStore];
        this.handleScroll = this.handleScroll.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    componentDidMount () {
        AppActions.getRandomSentences();
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount () {
        Reflux.Component.prototype.componentWillUnmount.call(this);
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll (event) {
        if (window.scrollY <= 0) {
            document.querySelector('.backHome').classList.remove('scrollNav');
            document.querySelector('.brandScroll').classList.remove('showBrand');
            document.querySelector('.SearchBtnInit').classList.remove('showSearchBtnInit');
        } else {
            document.querySelector('.backHome').classList.add('scrollNav');
            document.querySelector('.brandScroll').classList.add('showBrand');
            document.querySelector('.SearchBtnInit').classList.add('showSearchBtnInit');
        }
    }
    handleSearch (event) {
        let target = event.target;
        this.setState({query: target.value});
    }
    searchRedirect = () => {
        if (this.state.query.length > 1) {
            history.push('/search/' + this.state.query);
        }
    }
    selectSearch (event) {
        let query = event.currentTarget.dataset.query;
        this.setState({query: query});
    }
    responseFacebook (response) {
        let user = response;
        AppActions.loginUserFacebook(user);
    }
    logout () {
        AppActions.logout();
    }
    handleKeyPress (event) {
        if (event.key === 'Enter') {
            this.searchRedirect();
        }
    }
    render () {
        let query = this.state.query;
        let randomSentences = this.state.randomSentences.map((sentence) => {
            return <li key={sentence._id} ><Link className='btn-primary waves-effect waves-light' to={`/search/${sentence.sentence}`} role='button'>{sentence.sentence}</Link></li>;
        });
        return (
          <div className='topInit'>
            <div className='bottom' />
            <Header home />
            <div className='container-gral spaceTopInit'>
              <div className='col m12'>
                <div className='headerInit center-align'>
                  <div>
                    <img src='/images/icons/brand-beta.svg' />
                  </div>
                  <div className='search-init'>
                    <div className='search-box'>
                      <i className='fa fa-search' aria-hidden='true' />
                      <input placeholder='Busca por tema, categoría o palabra clave' value={query} onChange={this.handleSearch} onKeyPress={this.handleKeyPress} />
                    </div>
                    <div className='btn-search-home' onClick={this.searchRedirect} ><a className='btn-primary'>Buscar</a></div>
                  </div>
                </div>
                <ul className='last-tops center'>
                  {randomSentences}
                </ul>
              </div>
              <div className='clearfix' />
              <div className='bottom' />
            </div>
          </div>
        );
    }
}

export default HeaderBuscador;



// WEBPACK FOOTER //
// ./src/sections/HeaderBuscador.js